import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';

// custom.scss
import 'bootstrap/scss/bootstrap.scss';
//import 'bootstrap-vue/src/index.scss';

import '@/assets/global.css';
Vue.config.productionTip = false;

Vue.use(BootstrapVue);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
